angular.module('lf.common')

.factory('validationService', function(){
  var threeDigits = /^\d{3}$/,
      fourDigits = /^\d{4}$/;
  
  return {
    validateEmail: function(val){
      return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
    },

    validatePassword: function(val) {
      return /^[a-zA-Z0-9~`!@#$%^&*()\-_=+{}\[\]\\;:“‘<>,./?'\/"]{0,20}$/.test(val);
    },

    
    creditCard: {
      cardTypes: [
        {
          type: 'VISA',
          numPattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
          cvcPattern: threeDigits
        },
        {
          type: 'MC',
          numPattern: /^5[1-5][0-9]{14}$/,
          cvcPattern: threeDigits
        },
        {
          type: 'AMEX',
          numPattern: /^3[47][0-9]{13}$/,
          cvcPattern: fourDigits
        },
        {
          type: 'DISC',
          numPattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
          cvcPattern: threeDigits
        },
      ],

      luhnCheck: function (luhn) {
        if (!luhn) return false;
        var len = luhn.length,
          mul = 0,
          prodArr = [
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
          ],
          sum = 0;

        while (len--) {
          sum += prodArr[mul][parseInt(luhn.charAt(len), 10)];
          mul ^= 1;
        }

        return sum % 10 === 0 && sum > 0;
      },
      
      getCardType: function (cardNumber) {
        for (var i = 0; i < this.cardTypes.length; i++) {
          var cardType = this.cardTypes[i];
          if (cardType.numPattern.test(cardNumber)) {
            return cardType;
          }
        }
      },
      
      validateCreditCardNumber: function (val) {
        return this.luhnCheck(val) && !!this.getCardType(val);
      },
      
      validateCreditCardCvc: function (cvcVal, cardNum) {
        var cardType = this.getCardType(cardNum);
        return cardType && cardType.cvcPattern.test(cvcVal);
      }
    }
  };
});
